import * as React from "react";
import {useSelector} from "react-redux";
import {getActivePage} from "../slices/tableSlice";
import {LoadDataButton} from "./LoadDataButton";
import {OriginalFileViewer} from "./OriginalFileViewer";
import {IfBox} from "../../../../style/if";
import {MainViewFloatingButtons} from "./buttons/MainViewFloatingButtons";
import {TableView} from "./TableView";
import {FileTabBar} from "./FileTabBar";

export interface MainViewProps {
}

export function MainView(props: React.PropsWithChildren<MainViewProps>) {
    const activePage = useSelector(getActivePage)
    const [originalFiles, setOriginalFiles] = React.useState<File[]>([]);

    return <div className={"flex1"} style={{position: "relative"}}>
        <IfBox shouldShow={activePage?.pages.length > 0}
               else={
                   <LoadDataButton onFilesSelected={setOriginalFiles}/>
               }>
            <MainViewFloatingButtons/>
            <FileTabBar/>
            <OriginalFileViewer files={originalFiles}/>
            <div className={"flex1"}>
                <TableView/>
            </div>
        </IfBox>
    </div>
}